<template>
  <v-layout overlay-toolbar class="primary">
    <v-flex shrink ml-auto>
      <template>
        <v-slider
          class="reset-slider"
          :color="colorHex"
          :value="opacity"
          @input="$emit('updateOpacity', $event)"
          @change="$emit('change', $event)"
          always-dirty
          :min="0.0"
          :max="1.0"
          :step="0.05"
          :defaultValue="1.0">
        <template slot="prepend">
          <span class="slider-label">Overlay Transparency</span>
        </template>
        </v-slider>
      </template>
    </v-flex>
    <v-flex shrink>
      <v-checkbox 
        class="checkbox"
        :color="colorHex"
        :input-value="periscope"
        @click.stop="$emit('togglePeriscope')"/>
      <reset-slider
        :color="colorHex"
        :value="radius"
        :min="100"
        :max="500"
        :step="10"
        :defaultValue="100"
        @input="$emit('updateRadius', $event)"
        name="Periscope Radius"
        style="margin-left: 20px;"/>
    </v-flex>
    <v-flex shrink>
      <reset-slider
        :color="colorHex"
        :value="zoom"
        :min="1"
        :max="3"
        :step="0.05"
        :defaultValue="1"
        @input="$emit('updateZoom', $event)"
        name="Zoom"/>
    </v-flex>
    <v-flex shrink mr-auto>
      <v-btn class="modal-cta" @click="$emit('addImages')">Add Images</v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import resetSlider from "../controls/ResetSlider";

export default {
  name: "overlayToolbar",
  components: {resetSlider},
  props: ["transform", "radius", "opacity", "periscope"],
  computed: {
    zoom(){
      return this.transform && this.transform.zoom || 1;
    }
  }
};
</script>